module.exports = __webpack_public_path__ + "static/note-1-a5a3b9b05ee5b226c82008f3c2a5616e.jpg";